export const ratioString2PuissanceNiveauZoom = (distance, ratio) => {
  if (typeof distance === 'string' && distance.endsWith('px')) {
    const numericDistance = parseFloat(distance.slice(0, -2));
    if (!isNaN(numericDistance)) {
      return numericDistance * ratio + 'px';
    }
  }
  return null;
};
